export default __webpack_public_path__ + "static/media/enter_ticket_image_front.858619fc.png";